import React, { useEffect, useState, useRef } from "react";
import Modal from "react-responsive-modal";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import Cookies from "js-cookie";
import SearchIcon from "@mui/icons-material/Search";

const FineModel = ({ open, setOpen }) => {
  const { openToast, baseUrl, flowChangerToken } = useGlobalContext();
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [staffs, setStaffs] = useState([]);
  const [searchStaffName, setSearchStaffName] = useState("");
  const [resetFilter, setResetFilter] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsToShow, setRowsToShow] = useState(25);
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [staffActions, setStaffActions] = useState({}); // Tracks fines and overtime
  const firstRenderRef = useRef(true); // Track the first render

  console.log(searchStaffName);

  useEffect(() => {
    if (resetFilter) {
      setSearchStaffName(""); // Clear the input
      fetchStaffs(); // Fetch the default list
      setResetFilter(false); // Reset the state
    }
  }, [resetFilter]);
  
  const handleSearchStaff = async () => {
    // If searchStaffName is empty, fetch the default list
    if (!searchStaffName.trim()) {
      fetchStaffs(); 
      return;
    }
  
    const queryParams = new URLSearchParams();
    queryParams.append("name", searchStaffName);
    queryParams.append("role", ""); 
    queryParams.append("department", ""); 
  
    setIsLoading(true);
    try {
      const response = await fetch(`${baseUrl}staff/search?${queryParams}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      if (response.status === 200) {
        const result = await response.json();
        setStaffs(result?.data);
      } else {
        console.error("Error fetching staff");
      }
    } catch (error) {
      console.error("Error searching staff:", error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (!firstRenderRef.current) {
        handleSearchStaff();
      } else {
        firstRenderRef.current = false;
      }
    }, 800);
  
    return () => clearTimeout(debounceTimer);
  }, [searchStaffName]);
  

  const fetchStaffs = async () => {
    if (!Cookies.get("flowChangerAuthToken")) {
      setStaffs([]);
      setTotalPages(1);
      setTotalRecords(0);
      setIsLoading(false);
      return;
    }
    console.log("fetching staffs");
    try {
      setIsLoading(true);
      const response = await fetch(
        baseUrl + "staff?" + "page=" + currentPage + "&limit=5",
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
          },
        }
      );
      if (response.status == 200) {
        const data = await response.json();
        setStaffs(data?.data);
        setTotalPages(data?.meta?.totalPages);
        setTotalRecords(data?.meta?.totalRecords);
        setIsLoading(false);
      }
    } catch (error) {
      openToast("An Error Accured", "error");
    } finally {
      setIsLoading(false);
    }
  };
  const handlePrevious = () => {
    setStaffs([]);
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    fetchStaffs(currentPage, 5);
  };
  const handleNext = () => {
    setStaffs([]);
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    fetchStaffs(currentPage, 10);
  };

  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  
console.log("fetchStaffs",staffs);
  

  // Handle checkbox changes
  const handleCheckboxChange = (staffId, field, value) => {
    setStaffActions((prev) => ({
      ...prev,
      [staffId]: {
        ...prev[staffId],
        [field]: value,
      },
    }));
  };

  // Handle Save button click
  const handleSave = async () => {
    console.log("staffs in Fine Modal" ,staffs)
    const requestData = staffs.map((staff) => 
      (
      {
        id: staff?.staffDetails?.id, 
        overtime: staffActions[staff.id]?.overtime || false, 
        fine: staffActions[staff.id]?.fine || false,
      }))
      .filter((staff) => staff.overtime || staff.fine); 

    if (requestData.length === 0) {
        openToast("Please  select Atleast Fine or Overtime for staff member.", "error");
       return;
    }

    try {
      console.log("Sending data to API:", requestData);

      const response = await fetch(baseUrl + "/staff/apply", {
        method: "PUT",
        headers: { "Content-Type": "application/json" ,
         Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
},
        body: JSON.stringify({data:requestData}), 
      });

      if (response.status === 200) {
        openToast("Apply Fine and OverTime Successfully");
      
      } else {
        openToast("error while applying fine and overtime");
         }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  useEffect(() => {
    fetchStaffs();
  }, []);
  return (
    <div>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="flex flex-row justify-between items-center mb-[10px] pb-2 border-b">
          <h2 className="font-medium text-[20px] track-heading">
            Apply Fine & Overtime
          </h2>
        </div>
        <div className="space-y-4">
          <div className="relative border rounded-[22px]">
            <input
              type="text"
              className="p-[8px] pr-[34px] rounded-[22px] w-full focus:outline-none"
              value={searchStaffName}
              onChange={(e) => setSearchStaffName(e.target.value)}
              placeholder="Search...."
            />
            <SearchIcon className="top-[8px] right-[7px] absolute text-grey" />
          </div>
          <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-x-auto overflow-y-auto">
            <table className="border-[#dcdbdb] border rounded-lg w-full overflow-hidden table-auto table-section">
              <thead className='top-[-1px] sticky border-gray-300 bg-white set-shadow shadow-md" border className="cursor-pointer'>
                <tr>
                  <th className="border-[#dbdbdb] border-r text-center">
                    Name
                  </th>
                  <th className="border-[#dbdbdb] border-r text-center">
                    Fine
                  </th>
                  <th className="border-[#dbdbdb] border-r text-center">
                    OverTime
                  </th>
                </tr>
              </thead>
              <tbody>
                {staffs?.map((staff) => {
                  return (
                    <tr key={staff?.id} className="border">
                      <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                        {staff?.name}
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                        <input type="checkbox"   checked={staffActions[staff.id]?.fine || false}
                      onChange={(e) =>
                    handleCheckboxChange(staff.id, "fine", e.target.checked)
                  }/>
                      </td>
                      <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                        <input type="checkbox"  checked={staffActions[staff.id]?.overtime || false}
                  onChange={(e) =>
                    handleCheckboxChange(staff.id, "overtime", e.target.checked)
                  }/>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-[14px] xl:pr-0 pb-[0] xl:pl-0 w-[100%]">
            <p className="text-[#a5a1a1] text-[14px]">
              Total Records : {totalRecords}
            </p>
            <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className={`pt-2 pb-[8px] text-[12px] ${
                  currentPage == 1 ? "opacity-40" : ""
                }`}
              >
                Previous
              </button>
              <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">
                {/* {`Page ${currentPage} of ${totalPages}`} */}
                {currentPage}
              </span>
              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className={`pt-2 pb-[8px] text-[12px] ${
                  currentPage === totalPages ? "opacity-40" : ""
                }`}
              >
                Next
              </button>
            </div>
          </div>
          <button className="allcrm-btn p-[10px] w-full text-lg" size="lg"  onClick={handleSave}>
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default FineModel;
